import { cn, formatCurrency } from '@/lib/utils';
import { TIE_OUT_TOLERANCE } from './model';

export function Money({ value, currency = 'TRY', className }: { value: number; currency?: string; className?: string }) {
  return <span className={cn('font-mono tabular-nums', className)}>{formatCurrency(value, currency)}</span>;
}

/** A GL − cari difference: green when within tolerance, red otherwise. */
export function Difference({ value, currency = 'TRY' }: { value: number; currency?: string }) {
  const tied = Math.abs(value) <= TIE_OUT_TOLERANCE;
  return (
    <Money
      value={value}
      currency={currency}
      className={tied ? 'text-emerald-700 dark:text-emerald-300' : 'font-semibold text-red-700 dark:text-red-300'}
    />
  );
}

export function Stat({ label, value, tone = 'neutral' }: { label: string; value: React.ReactNode; tone?: 'neutral' | 'emerald' | 'red' | 'amber' }) {
  const tones = {
    neutral: 'border-border bg-card',
    emerald: 'border-emerald-200 bg-emerald-50 dark:border-emerald-800 dark:bg-emerald-900/20',
    red: 'border-red-200 bg-red-50 dark:border-red-800 dark:bg-red-900/20',
    amber: 'border-amber-200 bg-amber-50 dark:border-amber-800 dark:bg-amber-900/20',
  };
  return (
    <div className={cn('rounded-md border px-3 py-2', tones[tone])}>
      <div className="text-[11px] uppercase tracking-wide text-muted-foreground">{label}</div>
      <div className="text-sm font-semibold">{value}</div>
    </div>
  );
}
